import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: 'CocomatPro', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #000;
  }

  /* CocomatPro font family */
  @font-face {
    font-family: 'CocomatPro';
    src: url('/fonts/CocomatPro-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'CocomatPro';
    src: url('/fonts/CocomatPro-Bold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'CocomatPro';
    src: url('/fonts/CocomatPro-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'CocomatPro-Black';
    src: url('/fonts/CocomatPro-Black.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  /* Team Shield Styles */
  .team-shield {
    width: 48px !important;
    height: 48px !important;
    object-fit: contain;
    object-position: center;
    transition: transform 0.2s ease;
    
    &:hover {
      transform: scale(1.1);
    }
    
    @media (max-width: 768px) {
      width: 40px !important;
      height: 40px !important;
    }
  }
`;

// Layout Components
export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextCenter = styled.div`
  text-align: center;
`;

// Typography Components
export const MainHeading = styled.h1`
  font-family: 'CocomatPro-Black', 'CocomatPro', 'Arial Black', sans-serif;
  font-weight: 900 !important;
  font-size: 90px;
  line-height: 0.9;
  letter-spacing: -2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  margin: 0;
  
  @media (max-width: 1200px) {
    font-size: 80px;
  }  

  @media (max-width: 1024px) {
    font-size: 62px;
  }
  
  @media (max-width: 768px) {
    font-size: 42px;
  }
  
  @media (max-width: 480px) {
    font-size: 35px;
  }
`;

export const SubHeading = styled.div`
  font-family: 'CocomatPro', sans-serif;
  font-weight: normal;
  font-size: 62px;
  line-height: 1;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  
  @media (max-width: 1024px) {
    font-size: 48px;
  }
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
  
  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

export const BodyText = styled.p`
  font-family: 'CocomatPro', sans-serif;
  font-weight: normal;
  font-size: 35px;
  line-height: 1.2;
  margin: 10px 0 10px 0;
  opacity: 0.9;
  
  @media (max-width: 1024px) {
    font-size: 28px;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

// Button Components
export const PrimaryButton = styled.button`
  font-family: 'CocomatPro', sans-serif;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  border: none;
  border-radius: 25px;
  padding: 15px 35px;
  color: white;
  font-weight: bold;
  font-size: 11px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  }
  
  @media (max-width: 768px) {
    padding: 12px 30px;
    font-size: 10px;
  }
`;

// Card Components
export const GlassCard = styled.div`
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(0, 0, 0, 0.5));
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

// Grid Components
export const ResponsiveGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
  justify-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
    gap: 10px;
  }
`;

